import TianDingreseRvationDateComponent from "./reservationDate.vue";

export default {
    install(Vue, PluginOptions = {}) {
        const Constructor = Vue.extend(TianDingreseRvationDateComponent);
        Vue.component('td-reservation-date', Constructor);
    }
}


// WEBPACK FOOTER //
// ./src/_components/reservationDate/index.js